import React from 'react'
import { useDispatch } from 'react-redux'
import { FiMail } from '@react-icons/all-files/fi/FiMail'
import CorporateReadiness from './design-system/marketing/CorporateReadiness'
import QuotePop from './DeferredQuotePopup'
import { useOrderFlow } from './unified-order/OrderFlowProvider'
import { SHOW_POPUP } from '../store/slices/ui'
import * as gtag from '../lib/gtag'

const HomepageCorporateReadiness = ({ content }) => {
  const dispatch = useDispatch()
  const { launchIntent } = useOrderFlow()

  const trackCorporateDetails = () => gtag.event({
    action: 'home_corporate_readiness_details',
    label: 'corporate',
    value: 3,
    category: 'engagement'
  })

  const openQuote = () => {
    gtag.event({
      action: 'home_corporate_readiness_quote',
      label: 'leads',
      value: 5,
      category: 'orders'
    })
    launchIntent({
      sourceSurface: 'homepage_corporate_readiness',
      fulfillment: 'delivery_setup'
    }, () => dispatch(SHOW_POPUP({ key: 'quote', size: 'medium', body: <QuotePop /> })))
  }

  return (
    <CorporateReadiness
      content={content}
      headingId='homepage-corporate-readiness-title'
      variant='preview'
      primaryAction={{
        label: content?.primaryAction || 'View Corporate Production Details',
        href: '/corporate-event-production#corporate-procurement',
        onClick: trackCorporateDetails,
        dataConversionChannel: 'other',
        dataConversionKey: 'homepage.corporate-readiness.details',
        dataConversionLocation: 'corporate-readiness',
        dataConversionSalesPath: 'managed'
      }}
      secondaryAction={{
        label: content?.secondaryAction || 'Request a Production Quote',
        icon: FiMail,
        onClick: openQuote,
        dataConversionChannel: 'quote',
        dataConversionKey: 'homepage.corporate-readiness.quote',
        dataConversionLocation: 'corporate-readiness',
        dataConversionSalesPath: 'managed'
      }}
    />
  )
}

export default HomepageCorporateReadiness
